import React from 'react'
// import PropTypes from 'prop-types'
import R from 'ramda'

import { Label } from 'semantic-ui-react'
import searchHOC from '_forms/searchHOC'

const formatSelection = serial => {
  const _id = R.prop('_id', serial)
  const name = R.prop('name', serial)
  const email = R.prop('email', serial)
  return (
    <Label style={{display: 'inline-block'}} key={'sel_' + _id}>
      <div>{ name }</div>
      <div>{ email }</div>
      <div><small>{ _id }</small></div>
    </Label>
  )
}

const formatSuggestion = serial => (
  <div key={'sug_' + serial._id} >
    <div>{serial.name}</div>
    <div>{serial.email}</div>
    <div><small>{serial._id}</small></div>
  </div>
)

export const { PluralSearch, SingularSearch } = searchHOC({
  icon: 'barcode',
  placeholder: 'Type to search serials ...',
  idName: 'serialId',
  baseSearchUrl: 'serials',
  formatSelection,
  formatSuggestion
})



// WEBPACK FOOTER //
// ./webAdmin/forms/serialSearch.js